module.exports = __webpack_public_path__ + "img/sample_background.3757418c.jpg";